const KEY_CODE = {
    ENTER: 13,
    ESC: 27,
    CMD: 91,
    CTRL: 17,
    SHIFT: 16,
    TAB: 9,
    ARROW_LEFT: 37,
    ARROW_TOP: 38,
    ARROW_RIGHT: 39,
    ARROW_BOTTOM: 40,
}

export {KEY_CODE}